const config = {
  ENVIRONMENT_NAME: 'staging',
  forwoodId: {
    URL: 'https://id.staging.evolution.forwoodsafety.com',
    USER_TOKEN_URL: 'https://ptonucxkf4.execute-api.us-west-2.amazonaws.com/prod'
  },
  apiGateway: {
    REGION: 'us-west-2',
    URL: 'https://zjdiken609.execute-api.us-west-2.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'admin-container-1.11.5',
    HOSTNAME: 'https://admin.staging.evolution.forwoodsafety.com',
    COMPANY_MICROFRONTEND_URL: 'https://company.staging.evolution.forwoodsafety.com',
    PHYSICAL_LOCATION_MICROFRONTEND_URL: 'https://locations.staging.evolution.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.staging.evolution.forwoodsafety.com',
    WEBSOCKET: 'wss://gyaxuutzbl.execute-api.us-west-2.amazonaws.com/staging'
  },
  get forwoodIdAuthUrl() {
    return `${this.forwoodId.URL}/authorize?response_type=token&scope=openid&client_id=${this.forwoodId.APP_CLIENT_ID}&redirect_uri=${this.reactApp.HOSTNAME}&state=`;
  }
};

export default config;
